import {SessionProvider, signIn as originalSignIn, signOut as originalSignOut, useSession as originalUseSession} from "next-auth/react";
import React, {createContext} from "react";
import {SessionData, SignInResponse} from "@/base/types/SessionData";
import {Session} from "next-auth";

type UserStore = {}

const UserStoreContext = createContext<UserStore>({});

export type UseSessionType = {
	data?: SessionData
}

export const signOut = async () => {
	return originalSignOut({
		redirect: false,
	}).then(() => {
		return;
	});
}

export const signIn = async (token: string): Promise<SignInResponse | undefined> => {
	return originalSignIn("credentials", {
		redirect: false,
		token: token,
		// callbackUrl,
	}).then(res => {
		return res == undefined ? undefined : res as SignInResponse;
	})
}

export const useSession = (): UseSessionType => {
	// Can be used to extend session module (add local storage or other type of storage)
	// =================================================================================
	const {data} = originalUseSession();

	return {
		data: data as SessionData
	};
}

type Props = {
	session?: SessionData
}

export const UserStoreProvider = ({session, children}: React.PropsWithChildren<Props>) => {
	return (
		<SessionProvider session={session as Session}>
			<UserStoreContext.Provider value={{session}}>
				{children}
			</UserStoreContext.Provider>
		</SessionProvider>
	);
}